'use strict';

const urlUtils = require('./util/url');
const distanceUtils = require('./util/distance');

/**
 * get the closest store near the current location of the user
 * @param {any} stores - Array of stores
 * @param {Object} position the current position of the client
 * @returns {any} minimal information about nearest store
 */
function calculateNearestStore(stores, position) {
    var calculatedStores = [];

    stores.forEach(store => {
        var distance = distanceUtils.getDistanceFromLatLon(position, store.latitude, store.longitude);

        calculatedStores.push({
            ID: store.ID,
            name: store.name,
            distance: distance.mi,
            latitude: store.latitude,
            longitude: store.longitude
        });
    });

    calculatedStores.sort(function (a, b) {
        return a.distance - b.distance;
    });

    return calculatedStores[0];
}

/**
 * renders the most nearby store based on current location of the user
 */
function rendersMostNearbyStore() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
            var url = $('.js-storelocator-tile').data('stores-json-url');
            var urlParams = {
                lat: position.coords.latitude,
                long: position.coords.longitude
            };
            url = urlUtils.addOrReplaceQueryParameters(url, urlParams);

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    var nearestStore = calculateNearestStore(data.stores, position);
                    $('.js-storeTile-nearestshop').text(nearestStore ? nearestStore.name : '');

                    if (nearestStore) {
                        $('.js-storeTile-nearestshop').text(nearestStore.name);
                        var shopUrl = $('.js-storelocator-tile').data('stores-link-url');
                        shopUrl = urlUtils.addOrReplaceQueryParameters(shopUrl, {
                            store: nearestStore.ID
                        });
                        $('.js-storeTile-nearestshop').attr('href', shopUrl);
                    }
                }
            });
        });
    }
}

/**
 * handles the "use current lcation" button and redirects to Stores-Find with current position
 */
function handleCurrentLocationButton() {
    $('.js-use-current-location').on('click', function (e) {
        e.preventDefault();

        navigator.geolocation.getCurrentPosition(function (position) {
            var url = $('.js-storelocator-tile').data('stores-link-url');
            var urlParams = {
                lat: position.coords.latitude,
                long: position.coords.longitude
            };
            url = urlUtils.addOrReplaceQueryParameters(url, urlParams);

            window.location.href = url;
        });
    });
}

$(document).ready(function () {
    rendersMostNearbyStore();
    handleCurrentLocationButton();
});
